module.exports = __webpack_public_path__ + "media/images/activate/g2-trust-692f33d240783cc65f9593d4ea528450.png";